module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deground"
  }, [_c('headerpage', {
    attrs: {
      "status": 3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "adaptation",
    staticStyle: {
      "background-color": "#f6f8f7"
    }
  }, [(_vm.detail) ? _c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "cleft"
  }, [_c('div', {
    staticClass: "bg-white margin-bottom-20 box-shadow border-radius-10",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "flex justify-between padding-left-12 ",
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "company_logo",
    staticStyle: {
      "width": "115px",
      "height": "115px"
    }
  }, [_c('avatar-view', {
    attrs: {
      "size": 115,
      "fontSize": "32",
      "mod": "big",
      "name": _vm.detail.company_name
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "comright flex justify-between align-center"
  }, [_c('div', {
    staticClass: "bott"
  }, [_c('div', {
    staticClass: "comname",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.detail.company_name) + "\n                    "), _c('copy-btn', {
    attrs: {
      "text": _vm.detail.company_name
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-top-15"
  }, [(_vm.detail.operate_status) ? _c('el-tag', {
    staticClass: "bg-blueFF margin-right-8",
    attrs: {
      "effect": "dark",
      "size": "small "
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.detail.operate_status) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.detail.show.length) ? _vm._l((_vm.detail.show), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "bg-blueFF margin-right-8",
      attrs: {
        "effect": "dark",
        "size": "small "
      }
    }, [_vm._v("\n                        " + _vm._s(item) + "\n                      ")])
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "margin-top-15 timetext"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/images/icon7.png")
    }
  }), _vm._v("\n                    " + _vm._s(_vm.dayjs(Number(_vm.detail.updatetime) * 1000).format('YYYY-MM-DD')) + " 更新\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "gray-tag",
    staticStyle: {
      "font-size": "14px"
    }
  }, [(_vm.detail.city_str) ? _c('span', [_vm._v("#" + _vm._s(_vm.detail.city_str))]) : _vm._e(), (_vm.detail.district_str) ? _c('span', [_vm._v("#" + _vm._s(_vm.detail.district_str))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "12px",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticClass: "flex align-center margin-bottom-8"
  }, [_c('div', {
    staticClass: "fivewidth newmar text-cut"
  }, [_c('span', {
    staticClass: "lefttag"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('span', {
    staticClass: "righttag",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(_vm._s(_vm.detail.legal ? _vm.detail.legal : '--') + "\n                  ")]), _vm._v(" "), _c('copy-btn', {
    attrs: {
      "text": _vm.detail.legal
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fivewidth newmar text-cut"
  }, [_c('span', {
    staticClass: "lefttag"
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('span', {
    staticClass: "righttag"
  }, [_vm._v(_vm._s(_vm.emaillist.length ? _vm.emaillist[0] : '--'))]), _vm._v(" "), (_vm.emaillist.length) ? [_c('el-dropdown', [_c('span', {
    staticStyle: {
      "color": "#3290FD",
      "cursor": "pointer"
    }
  }, [_vm._v("查看更多")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_vm._l((_vm.emaillist), function(item, index) {
    return [_c('el-dropdown-item', [_vm._v(_vm._s(item) + "\n                            "), _c('copy-btn', {
      attrs: {
        "text": item
      }
    })], 1)]
  })], 2)], 1), _vm._v(" "), _c('copy-btn', {
    attrs: {
      "text": _vm.emaillist[0]
    }
  })] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "flex align-center margin-bottom-8"
  }, [_c('div', {
    staticClass: "fivewidth newmar text-cut"
  }, [_c('span', {
    staticClass: "lefttag"
  }, [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('span', {
    staticClass: "righttag"
  }, [_vm._v(_vm._s(_vm.detail.code ? _vm.detail.code : '--'))]), _vm._v(" "), _c('copy-btn', {
    attrs: {
      "text": _vm.detail.code
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fivewidth newmar  flex"
  }, [_c('span', {
    staticClass: "lefttag"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('div', {
    staticClass: "righttag",
    class: {
      'text-cut': !_vm.showAddress
    },
    staticStyle: {
      "max-width": "380px",
      "width": "auto"
    },
    attrs: {
      "id": "addressbox"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.detail.new_address ? _vm.detail.new_address : '--') + "\n                    "), (_vm.showAddress && _vm.detail.new_address.length > 24) ? _c('span', {
    staticClass: "cpoint",
    staticStyle: {
      "width": "40px",
      "color": "rgb(57, 129, 244)",
      "font-size": "15px"
    },
    on: {
      "click": function($event) {
        _vm.showAddress = false
      }
    }
  }, [_vm._v("收起")]) : _vm._e(), _vm._v(" "), _c('copy-btn', {
    attrs: {
      "text": _vm.detail.new_address
    }
  })], 1), _vm._v(" "), (!_vm.showAddress && _vm.detail.new_address.length > 24) ? _c('p', {
    staticClass: "cpoint",
    staticStyle: {
      "color": "rgb(57, 129, 244)",
      "font-size": "16px",
      "margin-left": "1%"
    },
    on: {
      "click": function($event) {
        _vm.showAddress = true
      }
    }
  }, [_vm._v("更多")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex align-center margin-bottom-8"
  }, [_c('div', {
    staticClass: "fivewidth newmar text-cut"
  }, [_c('span', {
    staticClass: "lefttag"
  }, [_vm._v("电话：")]), _vm._v(" "), (_vm.detail.phone) ? [
    [_vm._l((_vm.phonelist), function(item, index) {
      return [(index < 3) ? _c('span', {
        key: item,
        staticClass: "righttag"
      }, [_vm._v(_vm._s(item) + " ")]) : _vm._e(), _vm._v(" "), (index != _vm.phonelist.length - 1 && index < 2) ? _c('span', [_vm._v(",")]) : _vm._e()]
    })], _vm._v(" "), _c('copy-btn', {
      attrs: {
        "text": _vm.detail.phone
      }
    })
  ] : _c('span', {
    staticClass: "righttag",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('div', {
    staticClass: "fivewidth newmar text-cut"
  }, [_c('span', {
    staticClass: "lefttag"
  }, [_vm._v("网址：")]), _vm._v(" "), _c('span', {
    staticClass: "righttag",
    staticStyle: {
      "color": "#3290FD",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openWeb(_vm.detail.web)
      }
    }
  }, [_vm._v(_vm._s(_vm.detail.web ? _vm.detail.web : '暂无网址'))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start align-center",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('div', {
    staticClass: "flex justify-start align-start",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "lefttag"
  }, [_vm._v("简介：")]), _vm._v(" "), _c('div', {
    staticClass: "righttag2",
    class: _vm.showall ? '' : 'text-cut',
    staticStyle: {
      "max-width": "882px"
    },
    attrs: {
      "id": "righttag2"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.detail.business) + "\n                    "), (_vm.showall) ? _c('span', {
    staticClass: "cpoint",
    staticStyle: {
      "width": "40px",
      "color": "rgb(57, 129, 244)",
      "font-size": "14px"
    },
    on: {
      "click": function($event) {
        _vm.showall = false
      }
    }
  }, [_vm._v("收起")]) : _vm._e()]), _vm._v(" "), (!_vm.showall) ? _c('p', {
    staticClass: "cpoint",
    staticStyle: {
      "color": "rgb(57, 129, 244)",
      "font-size": "14px",
      "margin-left": "1%"
    },
    on: {
      "click": function($event) {
        _vm.showall = true
      }
    }
  }, [_vm._v("更多")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-shadow bg-white"
  }, [_c('div', {
    staticClass: "cnt-box"
  }, [_c('div', {
    staticClass: "boxt"
  }, [_c('div', {
    staticClass: "boxt_cent",
    class: _vm.tppindex == 0 ? 'boxtsty' : '',
    on: {
      "click": function($event) {
        _vm.tppindex = 0
      }
    }
  }, [_vm._v("\n                  政策信息\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "boxt_cent",
    class: _vm.tppindex == 1 ? 'boxtsty' : '',
    on: {
      "click": function($event) {
        _vm.tppindex = 1
      }
    }
  }, [_vm._v("\n                  基本信息\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "boxt_cent",
    class: _vm.tppindex == 2 ? 'boxtsty' : '',
    on: {
      "click": function($event) {
        _vm.tppindex = 2
      }
    }
  }, [_vm._v("\n                  联系方式 "), _c('span', [_vm._v("(" + _vm._s(_vm.numberData['a2'] || 0) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "boxt_cent",
    class: _vm.tppindex == 3 ? 'boxtsty' : '',
    on: {
      "click": function($event) {
        _vm.tppindex = 3
      }
    }
  }, [_vm._v("\n                  知识产权 "), _c('span', [_vm._v("(" + _vm._s(_vm.numberData['a3'] || 0) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "boxt_cent",
    class: _vm.tppindex == 4 ? 'boxtsty' : '',
    on: {
      "click": function($event) {
        _vm.tppindex = 4
      }
    }
  }, [_vm._v("\n                  资质证书 "), _c('span', [_vm._v("(" + _vm._s(_vm.numberData['a4'] || 0) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "boxt_cent",
    class: _vm.tppindex == 5 ? 'boxtsty' : '',
    on: {
      "click": function($event) {
        _vm.tppindex = 5
      }
    }
  }, [_vm._v("\n                  招投标 "), _c('span', [_vm._v("(" + _vm._s(_vm.numberData['a5'] || 0) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "boxt_cent",
    class: _vm.tppindex == 6 ? 'boxtsty' : '',
    on: {
      "click": function($event) {
        _vm.tppindex = 6
      }
    }
  }, [_vm._v("\n                  经营异常 "), _c('span', [_vm._v("(" + _vm._s(_vm.numberData['a6'] || 0) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "boxt_cent",
    class: _vm.tppindex == 7 ? 'boxtsty' : '',
    on: {
      "click": function($event) {
        _vm.tppindex = 7
      }
    }
  }, [_vm._v("\n                  司法信息 "), _c('span', [_vm._v("(" + _vm._s(_vm.numberData['a7'] || 0) + ")")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "40px"
    }
  })]), _vm._v(" "), _c('el-tabs', {
    staticClass: "detail-tabs",
    attrs: {
      "value": 'tppindex' + _vm.tppindex,
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "tppindex0",
      "lazy": ""
    }
  }, [_c('policy-page', {
    attrs: {
      "id": _vm.id
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "tppindex1",
      "lazy": ""
    }
  }, [_c('detail-page', {
    attrs: {
      "id": _vm.id,
      "detail": _vm.detail
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "tppindex2",
      "lazy": ""
    }
  }, [_c('contract-page', {
    attrs: {
      "id": _vm.id,
      "detail": _vm.detail
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "tppindex3",
      "lazy": ""
    }
  }, [_c('intellectual-page', {
    attrs: {
      "id": _vm.id,
      "detail": _vm.detail
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "tppindex4",
      "lazy": ""
    }
  }, [_c('certificate-page', {
    attrs: {
      "id": _vm.id,
      "detail": _vm.detail
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "tppindex5",
      "lazy": ""
    }
  }, [_c('tender-page', {
    attrs: {
      "id": _vm.id,
      "detail": _vm.detail
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "tppindex6",
      "lazy": ""
    }
  }, [_c('abnormal-page', {
    attrs: {
      "id": _vm.id,
      "detail": _vm.detail
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "tppindex7",
      "lazy": ""
    }
  }, [_c('judicial-page', {
    attrs: {
      "id": _vm.id,
      "detail": _vm.detail
    }
  })], 1)], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.showone.name,
      "visible": _vm.showimg
    },
    on: {
      "update:visible": function($event) {
        _vm.showimg = $event
      }
    }
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": "table"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "label"
  }, [_vm._v("证书名称")]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.showone.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "label"
  }, [_vm._v("证书编号")]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.showone.number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "label"
  }, [_vm._v("证书状态")]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.showone.status == 0 ? '无效' : '有效'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "label"
  }, [_vm._v("发证日期")]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.showone.date))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9d22b7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/comdetail.vue
// module id = 907
// module chunks = 1